import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import debounce from "lodash.debounce";
import md5 from "md5";
import { fetchProducts } from "./actions/appointmentActions";
import { refreshTimeout, refreshAlertText } from "./helpers";

import "./App.css";

import DayCardGroup from "./components/core/DayCardGroup";

const mapStateToProps = state => {
  return {
    appointments: state.appointments.appointments
  };
};

class App extends Component {
  appointmentDebounce = debounce(() => {
    const oldData = md5(JSON.stringify(this.props.appointments));
    localStorage.setItem("oldData", oldData);
    this.props.dispatch(fetchProducts());
  }, refreshTimeout);

  componentDidMount() {
    this.props.dispatch(fetchProducts());
    localStorage.removeItem("oldData");
  }
  componentDidUpdate() {
    const oldData = localStorage.getItem("oldData");
    if (oldData && oldData !== md5(JSON.stringify(this.props.appointments))) {
      alert(refreshAlertText);
      localStorage.removeItem("oldData");
    }
    this.appointmentDebounce();
  }
  componentWillUnmount() {
    localStorage.removeItem("oldData");
    this.appointmentDebounce.cancel();
  }
  render() {
    const { error, loading } = this.props.appointments;

    if (error) return <div>Error! {error.message}</div>;
    if (loading) return <div>Loading...</div>;

    return <DayCardGroup {...this.props.children} {...this.props} />;
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(App)
);
